import {Form, Table, Button, Row, Col, Container} from "react-bootstrap";
import React, {useCallback, useEffect, useState} from "react";
import {fetchPromises} from "../../core/utils/fetchPromises.js";
import {APIClient} from "../../core/utils/APIClient.js";
import {debounce} from "lodash";
import moment from "moment";
import MarketModal from "../market/MarketModal";
import { MultiSelect } from "react-multi-select-component";
// Icons
import alertIcon from "../../styles/assets/icons/alert.svg";
import exportIcon from "../../styles/assets/icons/export.svg";
import addIcon from "../../styles/assets/icons/add.svg";

function MarketPage(props) {
    const [articlesPrices, setArticlesPrices] = useState(props.articlesPrices);
    const [modal, setModal] = useState({ show: false });
    const [articleNameFilter, setArticleNameFilter] = useState();
    const [retailersFilter, setRetailersFilter] = useState(props.articlesPrices.retailers);
    const [brandFilter, setBrandFilter] = useState([]);
    const [countryFilter, setCountryFilter] = useState([]);

    useEffect(() => {
        setArticlesPrices(props.articlesPrices);
    }, [props.articlesPrices]);

    const onRetailersFilterChange = async (selectedRetailers) => {
        const selectedRetailerIds = selectedRetailers.map(r => r.value);
        const selectedBrandIds = brandFilter.length > 0 && brandFilter.map(r => r.value);
        const selectedCountryIds = countryFilter.length > 0 && countryFilter.map(r => r.value);

        const articlesPrices = await APIClient().getArticlesLastPrice(
            props.match.params.categoryId,
            articleNameFilter,
            selectedRetailerIds,
            selectedBrandIds,
            selectedCountryIds
        );

        setRetailersFilter(selectedRetailers);
        setArticlesPrices(articlesPrices);
    }

    const onArticleNameFilterChange = async (e) => {
        const articleName = e.target.value;

        setArticleNameFilter(articleName);
        debounceOnArticleNameFilterChange(articleName);
    }

    const onBrandFilterChange = async (selectedBrandFilter) => {
        const selectedRetailerIds = retailersFilter.map(r => r.value);
        const selectedBrandIds = selectedBrandFilter.length > 0 && selectedBrandFilter.map(r => r.value);
        const selectedCountryIds = countryFilter.length > 0 && countryFilter.map(r => r.value);

        const articlesPrices = await APIClient().getArticlesLastPrice(
            props.match.params.categoryId,
            articleNameFilter,
            selectedRetailerIds,
            selectedBrandIds,
            selectedCountryIds
        );
        setArticlesPrices(articlesPrices);
        setBrandFilter(selectedBrandFilter);
    }

    const onCountryFilterChange = async (selectedCountryFilter) => {
        const selectedRetailerIds = retailersFilter.map(r => r.value);
        const selectedBrandIds = brandFilter.length > 0 && brandFilter.map(r => r.value);
        const selectedCountryIds = selectedCountryFilter.length > 0 && selectedCountryFilter.map(r => r.value);
        
        const articlesPrices = await APIClient().getArticlesLastPrice(
            props.match.params.categoryId,
            articleNameFilter,
            selectedRetailerIds,
            selectedBrandIds,
            selectedCountryIds
        );

        const availableRetailers = props.retailers
            .filter((r) => selectedCountryFilter.length > 0 ? selectedCountryFilter.some(c => c.value === r.countryId) : true)
            .map((r) => ({ label: r.name, value: r.id, countryName: r.countryName }));

        setArticlesPrices(articlesPrices);
        setRetailersFilter(availableRetailers);
        setCountryFilter(selectedCountryFilter);
    }

    const debounceOnArticleNameFilterChange = useCallback(debounce(async (articleName) => {
        const selectedRetailerIds = retailersFilter.map(r => r.value);
        const selectedBrandIds = brandFilter.length > 0 && brandFilter.map(r => r.value);
        const selectedCountryIds = countryFilter.length > 0 && countryFilter.map(r => r.value);

        const articlesPrices = await APIClient().getArticlesLastPrice(
            props.match.params.categoryId,
            articleName,
            selectedRetailerIds,
            selectedBrandIds,
            selectedCountryIds
        );
        setArticlesPrices(articlesPrices)
    }, 200), []);

    const onAddClick = async (event) => {
        setModal({
            show: true,
            articleId: +event.currentTarget.dataset.aid,
            articleName: event.currentTarget.dataset.aname,
            retailerId: +event.currentTarget.dataset.rid,
            url: event.currentTarget.dataset.rurl,
            retailerName: event.currentTarget.dataset.rname,
            countryName: event.currentTarget.dataset.cname
        });
    }

    const onExportClick = async () => {
        window.open('/files/export');
    }

    const availableRetailers = props.retailers
        .filter((r) => countryFilter.length > 0 ? countryFilter.some(c => c.value === r.countryId) : true)
        .map((r) => ({ label: r.name, value: r.id }));

    return (
        <div className="w-100 d-flex flex-column overflow-hidden">
            <div className="page-header pt-2 pb-2">
                <Container fluid>
                    <Row className="align-items-center">
                        <Col lg>
                            <Form.Group>
                                <Form.Control size="md" name="articleName" value={articleNameFilter} onChange={onArticleNameFilterChange} placeholder="Article name" />
                            </Form.Group>
                        </Col>
                        <Col lg className="min-width-0">
                            <Form.Group>
                                <MultiSelect
                                    options={props.brands.map((c) => ({ label: c.name, value: c.id }))}
                                    value={brandFilter}
                                    onChange={onBrandFilterChange}
                                    labelledBy="Brand"
                                    overrideStrings={{
                                        selectSomeItems: "Brand",
                                    }}
                                />
                            </Form.Group>
                        </Col>
                        <Col lg className="min-width-0">
                            <Form.Group>
                                <MultiSelect
                                    options={props.countries.map((c) => ({ label: c.name, value: c.id }))}
                                    value={countryFilter}
                                    onChange={onCountryFilterChange}
                                    labelledBy="Country"
                                    overrideStrings={{
                                        selectSomeItems: "Country",
                                    }}
                                />
                            </Form.Group>
                        </Col>
                        <Col lg className="min-width-0">
                            <Form.Group>
                                <MultiSelect
                                    options={availableRetailers}
                                    value={retailersFilter}
                                    onChange={onRetailersFilterChange}
                                    labelledBy="Retailer"
                                    overrideStrings={{
                                        selectSomeItems: "Retailer",
                                    }}
                                />
                            </Form.Group>
                        </Col>
                        <Col xl="1" lg="2">
                            <Button variant="outline-primary" className="ms-1" size="sm" onClick={onExportClick}>
                                <img src={exportIcon} alt="export" />
                                <span>Export</span>
                            </Button>
                        </Col>
                    </Row>
                </Container>
            </div>
            <div className="page-content">
                {articlesPrices.articles && Object.keys(articlesPrices.articles).length === 0 ?
                    <p className="text-center pt-3">No results</p>
                    :
                    <Table hover className="mb-0 table-va-middle">
                        <thead>
                            <tr key="article">
                                <th>Article</th>
                                <th className="border-left">Brand</th>
                                <th colSpan={(retailersFilter && retailersFilter.length) || 0} className="border-left">
                                    Retailers
                                </th>
                                <th className="border-left color-orange text-end">AVG/L</th>
                            </tr>
                            <tr key="retailers">
                                <th className="secondary-title color-blue"></th>
                                <th className="secondary-title color-blue border-left"></th>
                                {retailersFilter && retailersFilter.map((r, index) =>
                                    <th key={index} className="secondary-title color-blue border-left text-end">
                                        <span className="font-weight-normal font-size-12">{r.countryName}</span><br />
                                        <span>{r.label}</span>
                                    </th>
                                )}
                                <th className="secondary-title color-blue border-left color-orange"></th>
                            </tr>
                        </thead>
                        <tbody>
                            {articlesPrices.articles && Object.keys(articlesPrices.articles).map((articleId, index) => {
                                const article = articlesPrices.articles[articleId];
                                return <tr key={index}>
                                    <td>{article.name}</td>
                                    <td className="border-left">{article.brandName}</td>
                                    {retailersFilter && retailersFilter.map((r) => {
                                        const retailerId = r.value;
                                        const retailerPrice = article.prices[retailerId];
                                        return retailerPrice ?
                                            <td key={retailerId} title={moment(retailerPrice.time).format("DD.MM.YYYY HH:mm:ss")} className="border-left text-end">
                                                <div className="d-flex justify-content-between">
                                                    <img
                                                        onClick={onAddClick}
                                                        src={addIcon}
                                                        alt=""
                                                        data-id={articleId}
                                                        data-aname={article.name}
                                                        data-aid={articleId}
                                                        data-rid={retailerId}
                                                        data-rurl={retailerPrice.url}
                                                        data-rname={r.label}
                                                        data-cname={r.countryName}
                                                        className="w12"
                                                    />
                                                    <a href={retailerPrice.url} target="_blank" rel="noreferrer" className="text-decoration-none">
                                                        {retailerPrice.price !== -1 ?
                                                            retailerPrice.price.toFixed(2) + "€"
                                                            :
                                                            <img src={alertIcon} alt="" className="me-1"/>
                                                        }
                                                    </a>
                                                </div>
                                            </td>
                                            :
                                            <td key={retailerId} className="border-left text-end">
                                                <div className="d-flex justify-content-between">
                                                    <img
                                                        onClick={onAddClick}
                                                        src={addIcon}
                                                        alt=""
                                                        data-aid={articleId}
                                                        data-aname={article.name}
                                                        data-rid={retailerId}
                                                        data-rname={r.label}
                                                        data-cname={r.countryName}
                                                        className="w12"
                                                    />
                                                    /
                                                </div>
                                            </td>
                                    })}
                                    <td className="color-orange text-end border-left">
                                        {article.sum && article.volumeMl ? (article.sum / article.numberOfPrices / article.volumeMl * 1000).toFixed(2) + '€' : '/'}
                                    </td>
                                </tr>
                            })}
                        </tbody>
                    </Table>
                }
                {modal.show &&
                    <MarketModal
                        articleId={modal.articleId}
                        articleName={modal.articleName}
                        retailerId={modal.retailerId}
                        retailerName={modal.retailerName}
                        url={modal.url}
                        countryName={modal.countryName}
                        setModal={setModal}
                        refreshArticleScanners={props.refresh}
                    />
                }
            </div>
        </div>
    );
}
export default fetchPromises({
    articlesPrices: () => ({ name: 'getArticlesLastPrice', props: ['match.params.categoryId'] }),
    brands: () => ({ name: 'getBrands' }),
    countries: () => ({ name: 'getCountries' }),
    retailers: () => ({ name: 'getRetailers' }),
})(MarketPage);
